import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getCategoriesFrontEnd } from "../../reducers/frontEndReducer";
import { Link } from 'react-router-dom';


const ServicesSection = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategoriesFrontEnd());
  }, [dispatch]);

  const { getCatsFrontEndData } = useSelector((state) => state.frontEndReducer);



  return (
    <div className="services-section container py-5">
      <h2 className="text-center fw-bold mb-5">Services</h2>
      <div className="row g-4">
        {getCatsFrontEndData?.length > 0 &&
          getCatsFrontEndData.map((data, index) => (
            <div className="col-md-4" key={index}>
              <div className="service-card p-4 h-100 rounded-4 shadow-sm text-start">
                <div className="icon-box text-success fs-1 mb-3">
                  <img src={data?.image} />
                  {/* <i className={data?.image}></i> */}
                </div>
                <h5 className="fw-bold mb-2">{data?.name}</h5>
                <p className="text-muted">{data?.description}</p>
                <Link
                  to={
                    data?.url ??
                    {
                      utr: "/utr",
                      gst: "/gst",
                      funds: "/funds"
                    }[data?.type]
                  }
                  className="fw-bold text-color text-decoration-none"
                >
                  Learn more <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ServicesSection;

